import script from "./CollectionActionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionActionBar.vue?vue&type=script&setup=true&lang=js"

import "./CollectionActionBar.vue?vue&type=style&index=0&id=18231d11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18231d11"]])

export default __exports__